import React from 'react';

const SIZES = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[2.5px]',
};

/**
 * Töltés-jelző: halvány gyűrű, rajta egy forgó lila ív — fénykör és izzás nélkül
 * (a sablon szerint semmi sem izzik).
 */
export default function LoadingSpinner({ size = 'md', fullPage = false, label }) {
  const spinner = (
    <span aria-hidden="true"
          className={`inline-block flex-none rounded-full border-white/10 border-t-brand-500 animate-spin ${SIZES[size] || SIZES.md}`} />
  );

  if (fullPage) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 min-h-[45vh]" role="status">
        {spinner}
        {label && <p className="text-sm text-gray-500">{label}</p>}
      </div>
    );
  }

  if (label) {
    return (
      <span className="inline-flex items-center gap-3" role="status">
        {spinner}
        <span className="text-sm text-gray-500">{label}</span>
      </span>
    );
  }

  return spinner;
}
